import * as THREE from 'three';

export function createLightingRig(): THREE.Group {
  const root = new THREE.Group();
  root.name = 'lightingRig';

  const hemisphere = new THREE.HemisphereLight('#f1efff', '#211c25', 1.4);
  hemisphere.name = 'coolFill';
  root.add(hemisphere);

  const key = new THREE.DirectionalLight('#fff0db', 3.05);
  key.name = 'warmKey';
  key.position.set(-6.5, 10.5, 5.5);
  key.castShadow = true;
  key.shadow.mapSize.set(2048, 2048);
  key.shadow.camera.near = 0.5;
  key.shadow.camera.far = 32;
  key.shadow.camera.left = -12;
  key.shadow.camera.right = 12;
  key.shadow.camera.top = 11;
  key.shadow.camera.bottom = -11;
  key.shadow.bias = -0.00035;
  key.shadow.normalBias = 0.035;
  key.shadow.radius = 4;
  root.add(key);

  const rim = new THREE.DirectionalLight('#b9b0ff', 1.35);
  rim.name = 'violetRim';
  rim.position.set(7.5, 7.4, -6.8);
  root.add(rim);

  const screenBounce = new THREE.RectAreaLight('#91adff', 1.8, 4.8, 2.2);
  screenBounce.name = 'screenBounce';
  screenBounce.position.set(-2.4, 5.8, 0.4);
  screenBounce.lookAt(-2.4, 0, 0.4);
  root.add(screenBounce);

  const boxHighlight = new THREE.SpotLight('#ffe3bb', 18, 20, Math.PI / 4.5, 0.78, 1.55);
  boxHighlight.name = 'boxHighlight';
  boxHighlight.position.set(6.8, 8, 4.5);
  boxHighlight.target.position.set(4.3, 0, -0.7);
  boxHighlight.castShadow = false;
  root.add(boxHighlight, boxHighlight.target);

  return root;
}
